import { LibraryCache } from 'base/library_cache';
import { EditorMode, editorModeStore } from './editor_mode';
import { SelectionStore } from './selection/store';
import { SidebarNavigation } from './sidebar/routes';

export function handleEscapeShortcut(
  selection: SelectionStore,
  sidebar: SidebarNavigation,
  library: LibraryCache,
) {
  if (sidebar.back) {
    return sidebar.back();
  }
  if (sidebar.at != null) {
    return sidebar.close();
  }
  handleSelectParentShortcut(selection, library);
}

export function handleSelectParentShortcut(
  selection: SelectionStore,
  library: LibraryCache,
) {
  const sel = selection.get();
  if (sel.element) {
    return selection.set(selection.factory.parentOfElementNode(sel, library));
  }
  if (sel.section) {
    return selection.set({ ...sel, section: undefined });
  }
  const mode = editorModeStore.get();
  if (sel.page) {
    return selection.set(
      mode === EditorMode.Sitemap
        ? selection.factory.treeParentOfPage(sel.page)
        : selection.factory.parentOfPage(sel.page),
    );
  }
  selection.set({});
}
